'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
  [
    '\n* { box-sizing: border-box; }\nbody {\n  margin: 0;\n  font-family: ',
    ";\n  line-height: 1.5;\n}\n\n@font-face {\n  font-family: Averta;\n  font-style: normal;\n  font-weight: 400;\n  font-display: optional;\n  src: url(//hackclub.com/fonts/averta-regular.woff2) format('woff2'), url(//hackclub.com/fonts/averta-regular.woff) format('woff');\n  unicode-range: U + 0000 - F8FE, U + F900-FFFF;\n}\n@font-face {\n  font-family: Averta;\n  font-style: normal;\n  font-weight: 700;\n  font-display: optional;\n  src: url(//hackclub.com/fonts/averta-bold.woff2) format('woff2'), url(//hackclub.com/fonts/averta-bold.woff) format('woff');\n  unicode-range: U + 0000 - F8FE, U + F900-FFFF;\n}\n"
  ],
  [
    '\n* { box-sizing: border-box; }\nbody {\n  margin: 0;\n  font-family: ',
    ";\n  line-height: 1.5;\n}\n\n@font-face {\n  font-family: Averta;\n  font-style: normal;\n  font-weight: 400;\n  font-display: optional;\n  src: url(//hackclub.com/fonts/averta-regular.woff2) format('woff2'), url(//hackclub.com/fonts/averta-regular.woff) format('woff');\n  unicode-range: U + 0000 - F8FE, U + F900-FFFF;\n}\n@font-face {\n  font-family: Averta;\n  font-style: normal;\n  font-weight: 700;\n  font-display: optional;\n  src: url(//hackclub.com/fonts/averta-bold.woff2) format('woff2'), url(//hackclub.com/fonts/averta-bold.woff) format('woff');\n  unicode-range: U + 0000 - F8FE, U + F900-FFFF;\n}\n"
  ]
)

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _styledComponents = require('styled-components')

var _styledComponents2 = _interopRequireDefault(_styledComponents)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

;(0, _styledComponents.injectGlobal)(_templateObject, _theme2.default.font)

var ThemeProvider = function ThemeProvider(props) {
  return _react2.default.createElement(
    _styledComponents.ThemeProvider,
    _extends(
      {
        theme: _theme2.default
      },
      props,
      {
        children: _react2.default.createElement(
          _react.Fragment,
          null,
          props.children
        )
      }
    )
  )
}

exports.default = ThemeProvider



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/ThemeProvider.js
// module id = 64
// module chunks = 35783957827783 64691314399603 114276838955818 228131777832141